$(function () {
	reload_breadcrumb_filter()
	init_quick_filter()

	if ($('.range-select').length > 0) {
		$('.range-select').each((k, i) => {
			let min = parseInt($(i).attr('data-min')),
				max = parseInt($(i).attr('data-max'));

			$(i).rangeSelect({
				min_val: min,
				max_val: max,
			});
		});
	}

	$('.quick-filter-more-btn').on('click', (e) => {
		let self = $(e.currentTarget),
			block = $('.quick-filter-list'),
			tl = gsap.timeline()

		self.toggleClass('show')
		block.toggleClass('show')

		if (block.hasClass('show')) {
			to(block, {height: "auto", duration: .6, ease: "easeTextCollapse"}, tl);
		} else {
			to(block, {height: '2rem', duration: .6, ease: "easeTextCollapse"}, tl);
		}
	});

	$(document).on('click', '.js-change-catalog-view', (e) => {
		let self = $(e.currentTarget),
			view = self.attr('data-catalog-view')

		e.preventDefault();

		if (view === 'list') {
			$('.js-view-parent').addClass('view-list');
		} else {
			$('.js-view-parent').removeClass('view-list');
		}

		$('.js-change-catalog-view').removeClass("active");
		self.addClass('active')

		product_slider_resize();
	});

	$(document).on('input', '.js-search-modal-filter', (e) => {
		let self = $(e.currentTarget),
			val = self.val().toLowerCase(),
			items = $('#modal-catalog-filter .filter-itm'),
			acord = $('#modal-catalog-filter .catalog-filter-accordion')

		if (val.length === 0) {
			items.removeClass('disable');
			acord.removeClass("disable");
			return false;
		}

		items.addClass('disable');
		acord.addClass("disable");

		items.each((i, itm) => {
			if ($(itm).text().toLowerCase().indexOf(val) !== -1) {
				$(itm).removeClass('disable');
				$(itm).closest('.catalog-filter-accordion').removeClass("disable");
			}
		});

	});

	$(document).on('click', '.modal-filter-current-itm', (e) => {
		let self = $(e.currentTarget),
			name = self.attr('data-name'),
			inputs = $(`[name="${name}"]`)

		inputs.first().trigger('click')

		e.preventDefault()
	})

	$(document).on('change', ".smartfilter input", (e) => {
		let self = $(e.currentTarget),
			name = self.attr('name')

		$("[name='" + name + "']").not(self).prop('checked', self.prop('checked'))

		reload_breadcrumb_filter();
	})

	function reload_breadcrumb_filter() {
		let form = $('.modal-catalog-filter'),
			block = $('.modal-filter-current')

		block.html("")

		form.find('input:checked').each((k, i) => {
			let name = $(i).siblings('.filter-itm__name').text(),
				cat_name = $(i).closest('.catalog-filter-accordion').find('.catalog-filter-accordion__head__name').text()

			if ($(i).hasClass('js-checkbox-switcher')) {
				name = $(i).prop('checked') ? "Да" : "Нет"
			}

			block.append(`<li>
							<a class="modal-filter-current-itm" data-name="${$(i).attr('name')}" href="">
							${cat_name}:  ${name}
							<span class="cross"></span>
							</a>
						  </li>`)
		})
	}

});


const init_quick_filter = () => {
	$('.quick-filter-list').each((k, i) => {
		if ($(i).find('.quick-filter-itm').length === 0) return
		const show = $(i).find('.quick-filter-itm').last().position().top < 20

		$(i).closest('.quick-filter').toggleClass('quick-filter--one-line', show)
	})
}